import React, { useMemo } from 'react';
import { Form, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import CardLayout from '../../../layouts/CardLayout';
import { ContractorForm } from '../../../components/Contractor/ContractorForm';
import { CONTRACTOR_CREATE } from '../../../graphql/mutations/contractors';
import { queries } from '../../../graphql/graphql';
import { ContractorFormValues } from '../../../types/contractor';

const ContractorCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm<ContractorFormValues>();

  const { data: usersData, loading: loadingUsers } = useQuery(queries.users.USERS);

  const userOptions = useMemo(() => {
    const users = usersData?.users || [];
    return users
      .filter((user: { roles?: string[] }) => user.roles?.includes('CONTRACTOR'))
      .map((user: { id: string; name: string; email: string }) => ({
        label: `${user.name} (${user.email})`,
        value: user.id,
      }));
  }, [usersData]);

  const [createContractor, { loading }] = useMutation(CONTRACTOR_CREATE, {
    onCompleted: data => {
      if (data?.contractorCreate) {
        message.success('Contractor created successfully');
        navigate(`/admin/contractor/${data.contractorCreate.id}`);
      }
    },
    onError: error => {
      message.error(error.message || 'Failed to create contractor');
    },
  });

  const handleFinish = (values: ContractorFormValues) => {
    createContractor({
      variables: {
        input: values,
      },
    });
  };

  return (
    <CardLayout>
      <ContractorForm
        form={form}
        loading={loading || loadingUsers}
        onFinish={handleFinish}
        submitText="Create Contractor"
        showUserField
        userOptions={userOptions}
      />
    </CardLayout>
  );
};

export default ContractorCreate;
